import { SignInView } from "@/features/auth/components/SignInView"

export default function SigninPage() {
  return <SignInView />
}